var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 256,
    height: 256,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#cacaca",
    height: 20,
    width: 20,
    y: 16,
    x: 16
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#1d43e5;#cacaca;#cacaca",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#cacaca",
    height: 20,
    width: 20,
    y: 16,
    x: 40
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.125s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#1d43e5;#cacaca;#cacaca",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#cacaca",
    height: 20,
    width: 20,
    y: 16,
    x: 64
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.25s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#1d43e5;#cacaca;#cacaca",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#cacaca",
    height: 20,
    width: 20,
    y: 40,
    x: 16
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.875s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#1d43e5;#cacaca;#cacaca",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#cacaca",
    height: 20,
    width: 20,
    y: 40,
    x: 64
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.375s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#1d43e5;#cacaca;#cacaca",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#cacaca",
    height: 20,
    width: 20,
    y: 64,
    x: 16
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.75s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#1d43e5;#cacaca;#cacaca",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#cacaca",
    height: 20,
    width: 20,
    y: 64,
    x: 40
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.625s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#1d43e5;#cacaca;#cacaca",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#cacaca",
    height: 20,
    width: 20,
    y: 64,
    x: 64
  }, /*#__PURE__*/React.createElement("animate", {
    calcMode: "discrete",
    begin: "0.5s",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.125;1",
    values: "#1d43e5;#cacaca;#cacaca",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingScreen);
export default __webpack_public_path__ + "static/media/loading-screen.5a8e8dbd58eab1e4968d2fd7e4dea574.svg";
export { ForwardRef as ReactComponent };